import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Stations from '@/pages/Stations.vue'
import StationsView from '@/pages/Stations/View.vue'
import StationsDetail from '@/pages/Stations/Detail.vue'
import StationsEdit from '@/pages/Stations/Edit.vue'

import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'

import Sensors from '@/pages/Sensors.vue'
import SensorsView from '@/pages/Sensors/View.vue'
import SensorsEdit from '@/pages/Sensors/Edit.vue'
import SensorsDetail from '@/pages/Sensors/Detail.vue'

import Maps from '@/pages/Maps.vue'

import Stats from '@/pages/Stats.vue'
import StatsView from '@/pages/Stats/View.vue'


import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'



const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						name: "Settings",
						component: SettingsView
					}
				]
			},
			// {
			// 	path: 'stations',
			// 	component: Stations,
			// 	children: [
			// 		{
			// 			path: '',
			// 			name: "ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់",
			// 			component: StationsView
			// 		},
			// 		{
			// 			path: 'detail/:hash_id',
			// 			name: 'ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់',
			// 			component: StationsDetail
			// 		},
			// 		{
			// 			path: 'edit/:hash_id',
			// 			name: 'ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់',
			// 			component: StationsEdit
			// 		}
			// 	]
			// },
			{
				path: 'sensors',
				component: Sensors,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: SensorsView
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: SensorsDetail
					},
					{
						path: 'edit/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: SensorsEdit
					}
				]
			},
			{
				path: 'maps',
				component: Maps
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						name: "Administrators",
						component: AdministratorsView
					},
					{
						path: 'edit/:id',
						name: 'Administrators',
						component: AdministratorsEdit
					}
				]
			},

		]
	},
	{
		path: '/map-view',
		component: Maps
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js